import React, { useState, useEffect } from 'react';
import { SCROLL_EVENT, SCROLL_THRESHOLD, SCROLL_BEHAVIOR } from '../../utils/scrollToTopConstants';
import { useChat } from '../../context/ChatContext';

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);
    const { isChatbotOpen } = useChat();

    const toggleVisibility = () => {
        if (window.pageYOffset > SCROLL_THRESHOLD) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: SCROLL_BEHAVIOR,
        });
    };

    useEffect(() => {
        window.addEventListener(SCROLL_EVENT, toggleVisibility);
        return () => {
            window.removeEventListener(SCROLL_EVENT, toggleVisibility);
        };
    }, []);

    // Handle render with animation timing
    useEffect(() => {
        if (isVisible) {
            setShouldRender(true);
        } else {
            const timer = setTimeout(() => {
                setShouldRender(false);
            }, 400); // Slightly longer for smooth exit
            return () => clearTimeout(timer);
        }
    }, [isVisible]);

    if (isChatbotOpen) {
        return null;
    }

    return (
        <>
            {shouldRender && (
                <button
                    onClick={scrollToTop}
                    className={`
                        fixed hidden md:block mb-4 bottom-32 md:bottom-24 right-10 z-50 
                        p-2 rounded-full bg-[#2563EB] text-white shadow-lg hover:bg-[#1D4ED8] 
                        hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#2563EB] 
                        focus:ring-offset-2
                        transition-all duration-400 ease-[cubic-bezier(0.34,1.56,0.64,1)]
                        ${isVisible 
                            ? 'opacity-100 translate-y-0 scale-100' 
                            : 'opacity-0 translate-y-10 scale-50'
                        }
                    `}
                    aria-label="Scroll to top"
                >
                    <svg
                        className="w-4 h-4 transition-transform duration-300 group-hover:scale-110"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M5 10l7-7m0 0l7 7m-7-7v18"
                        />
                    </svg>
                </button>
            )}
        </>
    );
};

export default ScrollToTopButton;